import { useDispatch } from "react-redux";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { ClientsService } from "../services/clients";
import { ClientRelationshipReview } from "../types/clients-module-types";
import eventHandler from "../../SharedModule/utils/eventHandler";

export type reviewPayload = {
  review: ClientRelationshipReview;
};

export const useChangeStatusRelationship = (
  showModal: (options: any) => Promise<void>,
  closeModal: () => void,
  isShowingActives: boolean,
  setShowActives: Function,
  setLoadingReviews: Function
) => {
  const dispatch = useDispatch();
  const changeStatus = async (payload: reviewPayload) => {
    const options = {
      title: `${
        isShowingActives ? "Deactivate" : "Reactivate"
      } Relationship Review?`,
      text: `Are you sure you want to ${
        isShowingActives ? "deactivate" : "reactivate"
      } this Relationship Review?`,
      btnLabel: `${isShowingActives ? "Deactivate" : "Reactivate"}`,
    };
    await showModal(options);
    closeModal();

    await ClientsService.updateRelationshipReview({
      clientId: payload.review.clientId,
      costCenterId: payload.review.costCenterId,
      name: payload.review.name,
      id: payload.review.id,
      isActive: !payload.review.isActive,
    })
      .then((response) => {
        dispatch(setLoadingReviews(true));
        dispatch(addToast({ mode: "success", message: response.message }));
        setShowActives(!payload.review.isActive);
      })
      .catch(() => {
        dispatch(
          addToast({
            mode: "error",
            message: "Something went wrong updating this relationship review",
          })
        );
      });
    eventHandler.dispatch("toast action", { isClosed: false });
  };

  return changeStatus;
};
